import { render } from "./ObjectEditor.vue?vue&type=template&id=45bc84d3&scoped=true&ts=true"
import script from "./ObjectEditor.vue?vue&type=script&lang=ts"
export * from "./ObjectEditor.vue?vue&type=script&lang=ts"

import "./ObjectEditor.vue?vue&type=style&index=0&id=45bc84d3&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/test-saas-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45bc84d3"]])

export default __exports__